import React from 'react';
import { Link } from 'react-router-dom';
import cn from '@/utils/cn';
import Icon from '@/components/ui/Icon';
import { ProgramLesson } from './types';

interface SharedProgramsCellProps {
  lesson: ProgramLesson;
  programId: number;
}

const triggerClass = cn(
  'tw-inline-flex tw-items-center tw-gap-1',
  'tw-text-spa-accent-text hover:tw-text-spa-accent-text-hover',
  'tw-no-underline tw-transition-colors',
);

const SharedProgramsCell = ({ lesson, programId }: SharedProgramsCellProps) => {
  const programIds = lesson.program_ids || [];
  const isShared = programIds.some(id => id !== programId);

  if (!isShared) return <span>{programIds.length}</span>;

  return (
    <Link
      aria-label={`Shared programs for ${lesson.title}`}
      className={triggerClass}
      to={`lessons/${lesson.id}/shared-programs`}
    >
      <Icon icon="Venn" size={16} />
      {programIds.length}
    </Link>
  );
};

export default SharedProgramsCell;
